
import './App.css';
import EidCardPage from './components/EidCardPage';

function App() {
  return (
    <div className="App">
     <EidCardPage/>
    </div>
  );
}

export default App;
